// extracted by mini-css-extract-plugin
var _1 = "ys1wVI_LTm";
var _2 = "HQWiW_COq7";
export { _1 as "content", _2 as "root" }
